import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import axios from 'axios';
import 'moment/locale/es';
const NotificationItem = ({ notification, deleteCallback }) => {
    moment.locale('es');
  return (
    <div className="notificacionItem-container">
      <div class="alert " role="alert">
       <span className="date-notification">{moment(notification.createdDate).startOf('hour').fromNow()}:</span> {notification.description}
      </div>
      <button
        className="fa fa-trash"
        style={{ color: 'rgb(225, 29, 72)' }}
        onClick={
          ()=>{
            axios.delete(`notification/${notification.id}/delete`).then(result=>{
              if(result.data.message==='Notificación Eliminada!')
              deleteCallback()
            })
          }
        }> </button>



    </div>
  );
};

export default NotificationItem;
